<template>
  <div class="min-h-[calc(100vh-80px)] flex flex-col gap-10 items-center justify-center">
    <!-- Inner div -->
    <div class="w-[450px] flex flex-col gap-[16px]">
      <!-- Text content (Welcome) -->
      <h1 class="w-[450px] h-[38px] font-minion text-[#121212] text-[32px] leading-[38.4px] font-semibold" 
          style=" letter-spacing: 0%; margin: 0">
        Welcome to Ask A Fundraiser
      </h1>

      <!-- New Text content -->
      <p class="w-[450px] h-[72px] text-[#666666] text-[16px] leading-[24px] font-semibold" 
         style="font-family: 'Open Sans'; font-weight: 600; letter-spacing: 0%; margin: 0">
        This Fundraising and Sustainability Toolkit was developed to help your organization build a sustainable fundraising plan.
      </p>
    </div>

    <!-- Button Component -->
    <div class="w-[450px] h-[48px] gap-[24px]">
      <NextButton 
        text="Get Started" 
        nextRoute="organization"
      />
    </div>
  </div>
</template>

<script setup>
import NextButton from "@/components/NextButton.vue";
</script>
